/**
 * スタッフ有効化/停止ダイアログ専用i18n定数
 */

export const STAFF_ACTIVATION_I18N = {
  // ステータス
  status: {
    active: $localize`:@@admin.staffActivation.status.active:有効`,
    inactive: $localize`:@@admin.staffActivation.status.inactive:無効`,
  },

  // アカウントグループ
  accountGroup: {
    staff: $localize`:@@admin.staffActivation.accountGroup.staff:スタッフアカウント`,
    user: $localize`:@@admin.staffActivation.accountGroup.user:一般ユーザー`,
  },

  // ダイアログ
  dialog: {
    deleteTitle: $localize`:@@admin.staffActivation.dialog.deleteTitle:登録の削除`,
    deleteMessage: $localize`:@@admin.staffActivation.dialog.deleteMessage:このまま進むと、このページに戻れなくなる可能性があります。よろしいですか？`,
  },

  // ボタン
  button: {
    close: $localize`:@@admin.staffActivation.button.close:閉じる`,
  },

  // メッセージ
  message: {
    updateSuccess: $localize`:@@admin.staffActivation.message.updateSuccess:更新が完了しました。`,
    updateError: $localize`:@@admin.staffActivation.message.updateError:更新に失敗しました。再度お試しください。`,
    invalidMemberId: $localize`:@@admin.staffActivation.message.invalidMemberId:ERROR: メンバーIDの値が不正です。`,
  },
} as const;

export type StaffActivationI18n = typeof STAFF_ACTIVATION_I18N;
